import { TOGGLE_OPTIONAL_RENDER } from './constants';
import { changePreviewHiddenComponents } from '../actions';
export const toggleOptional = (isChecked, componentIdent) => (dispatch) => {
    dispatch({
        type: TOGGLE_OPTIONAL_RENDER,
        isHidden: !isChecked,
        componentIdent,
    });
    dispatch(changePreviewHiddenComponents());
};
//# sourceMappingURL=actions.js.map